import React, { useState } from "react";
import { axiosRequest } from "../../utility/axios";

const API_URL = process.env.REACT_APP_API_URL;

// Mirrors cmsCLub-dev/controller/spinWheel.js's PRIZE_TIERS -- display/wheel-layout only,
// the actual prize is always picked server-side. Order matters: it must match the
// segment order drawn below so the spin animation lands on the segment the server chose.
const PRIZE_TIERS = [50, 100, 150, 250, 500, 1000, 2500];
const SEGMENT_COLORS = ["#FFD700", "#FF6B6B", "#4ECDC4", "#FFA500", "#00CED1", "#FF69B4", "#8A2BE2"];
const SEGMENT_ANGLE = 360 / PRIZE_TIERS.length;

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@700;900&family=Cinzel:wght@500;700;900&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
.sw-root{min-height:100vh;min-height:100dvh;background:radial-gradient(ellipse at 30% 0%,#1a1408 0%,#050403 55%,#000 100%);
  color:#fff;font-family:'Cinzel','Georgia',serif;display:flex;flex-direction:column;align-items:center;
  padding:clamp(18px,4vw,40px) 16px 60px;overflow-x:hidden;}
.sw-club{font-size:11px;letter-spacing:5px;color:rgba(255,215,0,.65);text-transform:uppercase;margin-top:6px;}
.sw-title{font-family:'Cinzel Decorative','Georgia',serif;font-weight:900;font-size:clamp(24px,6vw,38px);
  background:linear-gradient(90deg,#9a6f00,#FFD700,#FFEC8B,#FFA500,#FFD700,#9a6f00);background-size:300%;
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
  animation:sw-shimmer 4s linear infinite;letter-spacing:.5px;margin-top:4px;text-align:center;}
@keyframes sw-shimmer{0%{background-position:0% center;}100%{background-position:300% center;}}
.sw-sub{font-size:13px;color:rgba(255,255,255,.55);margin-top:8px;text-align:center;max-width:340px;}
.sw-card{width:100%;max-width:420px;margin-top:26px;background:linear-gradient(180deg,rgba(30,24,10,.9),rgba(10,8,4,.95));
  border:1px solid rgba(255,215,0,.3);border-radius:20px;padding:22px 20px;box-shadow:0 0 40px rgba(255,215,0,.1),0 14px 40px rgba(0,0,0,.5);}
.sw-search-box{display:flex;gap:8px;background:rgba(255,255,255,.04);border:1px solid rgba(255,215,0,.3);border-radius:14px;padding:6px;}
.sw-input{flex:1;background:transparent;border:none;color:#fff;font-size:16px;padding:11px 12px;font-family:inherit;}
.sw-input:focus{outline:none;}
.sw-input::placeholder{color:rgba(255,255,255,.35);}
.sw-btn{background:linear-gradient(135deg,#FFD700,#FFA500);color:#1a1408;border:none;border-radius:10px;
  padding:0 20px;font-weight:800;font-size:14px;cursor:pointer;font-family:inherit;letter-spacing:.3px;}
.sw-btn:disabled{opacity:.5;cursor:default;}
.sw-err{margin-top:14px;text-align:center;color:#ff8a8a;background:rgba(255,60,60,.08);
  border:1px solid rgba(255,60,60,.3);border-radius:12px;padding:12px;font-size:13.5px;}
.sw-player{margin-top:18px;text-align:center;}
.sw-player-name{font-weight:800;font-size:18px;}
.sw-player-id{font-size:12px;color:rgba(255,255,255,.5);margin-top:2px;}
.sw-already{margin-top:16px;text-align:center;background:rgba(255,255,255,.04);border:1px solid rgba(255,215,0,.25);
  border-radius:14px;padding:18px;}
.sw-already-title{font-weight:800;font-size:16px;color:#FFD700;}
.sw-already-sub{font-size:13px;color:rgba(255,255,255,.6);margin-top:6px;}
.sw-wheel-wrap{position:relative;width:min(78vw,300px);height:min(78vw,300px);margin:24px auto 8px;}
.sw-pointer{position:absolute;top:-14px;left:50%;transform:translateX(-50%);width:0;height:0;
  border-left:14px solid transparent;border-right:14px solid transparent;border-top:22px solid #FFD700;
  z-index:5;filter:drop-shadow(0 2px 4px rgba(0,0,0,.5));}
.sw-wheel{width:100%;height:100%;border-radius:50%;position:relative;border:6px solid #FFD700;
  box-shadow:0 0 30px rgba(255,215,0,.4),0 10px 40px rgba(0,0,0,.5);
  transition:transform 4.2s cubic-bezier(.17,.89,.32,1.1);}
.sw-seg-label{position:absolute;top:8%;left:50%;font-size:clamp(11px,2.6vw,14px);font-weight:800;color:#1a1408;
  transform-origin:0 150%;white-space:nowrap;text-shadow:0 1px 1px rgba(255,255,255,.3);}
.sw-hub{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:22%;height:22%;border-radius:50%;
  background:radial-gradient(circle,#fff,#FFD700);border:3px solid #1a1408;box-shadow:0 0 14px rgba(255,215,0,.6);z-index:4;}
.sw-spin-btn{margin-top:22px;width:100%;background:linear-gradient(135deg,#FFD700,#FFA500);color:#1a1408;
  border:none;border-radius:14px;padding:16px;font-weight:900;font-size:17px;letter-spacing:1px;
  cursor:pointer;font-family:'Cinzel Decorative','Georgia',serif;box-shadow:0 6px 20px rgba(255,165,0,.35);}
.sw-spin-btn:disabled{opacity:.55;cursor:default;}
.sw-reset{margin-top:14px;background:transparent;border:1px solid rgba(255,255,255,.25);color:rgba(255,255,255,.7);
  border-radius:10px;padding:8px 16px;font-size:12px;cursor:pointer;font-family:inherit;}
.sw-result-wrap{position:fixed;inset:0;z-index:20;display:flex;align-items:center;justify-content:center;
  background:rgba(0,0,0,.6);backdrop-filter:blur(4px);padding:20px;}
.sw-result-box{background:linear-gradient(180deg,rgba(30,24,10,.98),rgba(10,8,4,.99));border:3px solid #FFD700;
  border-radius:22px;padding:32px 36px;text-align:center;box-shadow:0 0 60px rgba(255,215,0,.4),0 20px 60px rgba(0,0,0,.5);
  animation:sw-bang-in .5s cubic-bezier(.34,1.56,.64,1);max-width:90vw;}
@keyframes sw-bang-in{0%{transform:scale(.3) rotate(-6deg);opacity:0;}60%{transform:scale(1.06) rotate(2deg);}100%{transform:scale(1) rotate(0);opacity:1;}}
.sw-result-label{font-size:13px;letter-spacing:3px;color:rgba(255,215,0,.7);text-transform:uppercase;font-weight:700;}
.sw-result-amt{font-family:'Cinzel Decorative','Georgia',serif;font-weight:900;font-size:clamp(36px,9vw,56px);
  color:#FFD700;margin-top:8px;text-shadow:0 0 20px rgba(255,215,0,.6);}
.sw-result-sub{margin-top:10px;font-size:13px;color:rgba(255,255,255,.6);}
.sw-result-close{margin-top:20px;background:linear-gradient(135deg,#FFD700,#FFA500);color:#1a1408;border:none;
  border-radius:10px;padding:10px 28px;font-weight:800;font-size:14px;cursor:pointer;font-family:inherit;}
`;

export default function SpinWheel() {
  const [query, setQuery] = useState("");
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState("");
  const [player, setPlayer] = useState(null);
  const [alreadySpun, setAlreadySpun] = useState(false);
  const [todaysPrize, setTodaysPrize] = useState(null);

  const [rotation, setRotation] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState(null); // { prize_amount, promotional_balance }
  const [spinError, setSpinError] = useState("");

  const handleCheck = async (e) => {
    e.preventDefault();
    const value = query.trim();
    if (!value) return;
    setChecking(true);
    setError("");
    setPlayer(null);
    const res = await axiosRequest("GET", `${API_URL}/spin-wheel/check?query=${encodeURIComponent(value)}`, null);
    setChecking(false);
    const payload = res?.data;
    if (!payload) return setError("Network error. Please try again.");
    if (!payload.found) return setError(payload.message || "No player found with that ID or phone number.");
    setPlayer(payload.player);
    setAlreadySpunToday(payload.alreadySpunToday, payload.todaysPrize);
  };

  const setAlreadySpunToday = (already, prize) => {
    setAlreadySpun(already);
    setTodaysPrize(prize);
  };

  const reset = () => {
    setQuery("");
    setPlayer(null);
    setAlreadySpun(false);
    setTodaysPrize(null);
    setRotation(0);
    setResult(null);
    setSpinError("");
  };

  const handleSpin = async () => {
    if (spinning || !player) return;
    setSpinning(true);
    setSpinError("");
    const res = await axiosRequest("POST", `${API_URL}/spin-wheel/redeem`, null, { query: player.playerId });
    const payload = res?.data;
    if (!payload) {
      setSpinning(false);
      return setSpinError("Network error. Please try again.");
    }
    if (!payload.status) {
      setSpinning(false);
      setSpinError(payload.message || "Something went wrong.");
      if (payload.message?.toLowerCase().includes("already spun")) setAlreadySpunToday(true, null);
      return;
    }

    const idx = Math.max(0, PRIZE_TIERS.indexOf(payload.prize_amount));
    const segCenter = idx * SEGMENT_ANGLE + SEGMENT_ANGLE / 2;
    const spins = 6;
    const targetRotation = rotation + spins * 360 + (360 - segCenter) - (rotation % 360);

    setRotation(targetRotation);
    setTimeout(() => {
      setSpinning(false);
      setResult({ prize_amount: payload.prize_amount, promotional_balance: payload.promotional_balance });
    }, 4300);
  };

  return (
    <div className="sw-root">
      <style>{CSS}</style>
      <div className="sw-club">Real Gaming Club</div>
      <div className="sw-title">🎡 Spin & Win</div>
      <div className="sw-sub">Enter your Player ID or phone number for a free daily spin — win instant promo credit!</div>

      <div className="sw-card">
        {!player ? (
          <>
            <form className="sw-search-box" onSubmit={handleCheck}>
              <input
                className="sw-input"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Player ID or phone number"
                autoFocus
              />
              <button className="sw-btn" type="submit" disabled={checking || !query.trim()}>
                {checking ? "..." : "Check"}
              </button>
            </form>
            {error && <div className="sw-err">{error}</div>}
          </>
        ) : (
          <>
            <div className="sw-player">
              <div className="sw-player-name">{player.name || player.playerId}</div>
              <div className="sw-player-id">ID: {player.playerId}</div>
            </div>

            {alreadySpun ? (
              <div className="sw-already">
                <div className="sw-already-title">🎉 You've already spun today!</div>
                <div className="sw-already-sub">
                  {todaysPrize ? `You won ₹${todaysPrize.toLocaleString("en-IN")} today. ` : ""}
                  Come back tomorrow for another free spin.
                </div>
              </div>
            ) : (
              <>
                <div className="sw-wheel-wrap">
                  <div className="sw-pointer" />
                  <div
                    className="sw-wheel"
                    style={{
                      transform: `rotate(${rotation}deg)`,
                      background: `conic-gradient(${PRIZE_TIERS.map(
                        (_, i) => `${SEGMENT_COLORS[i % SEGMENT_COLORS.length]} ${i * SEGMENT_ANGLE}deg ${(i + 1) * SEGMENT_ANGLE}deg`
                      ).join(",")})`,
                    }}
                  >
                    {PRIZE_TIERS.map((amt, i) => (
                      <div
                        key={amt}
                        className="sw-seg-label"
                        style={{ transform: `rotate(${i * SEGMENT_ANGLE + SEGMENT_ANGLE / 2}deg)` }}
                      >
                        ₹{amt}
                      </div>
                    ))}
                    <div className="sw-hub" />
                  </div>
                </div>

                <button className="sw-spin-btn" onClick={handleSpin} disabled={spinning}>
                  {spinning ? "Spinning…" : "SPIN NOW"}
                </button>
                {spinError && <div className="sw-err">{spinError}</div>}
              </>
            )}

            <div style={{ textAlign: "center" }}>
              <button className="sw-reset" onClick={reset}>Not you? Search again</button>
            </div>
          </>
        )}
      </div>

      {result && (
        <div className="sw-result-wrap">
          <div className="sw-result-box">
            <div className="sw-result-label">🏆 You Won 🏆</div>
            <div className="sw-result-amt">₹{result.prize_amount.toLocaleString("en-IN")}</div>
            <div className="sw-result-sub">Credited straight to your promo wallet. Come back tomorrow for another spin!</div>
            <button className="sw-result-close" onClick={reset}>Done</button>
          </div>
        </div>
      )}
    </div>
  );
}
